import { setDeviceOrientation } from './redux/actions';

export const setDeviceOrientationType = (store) => {
  window.addEventListener('orientationchange', function() {
    if(navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) {
      store.dispatch(setDeviceOrientation(window.orientation))
    } else {
      store.dispatch(setDeviceOrientation(window.screen.orientation.angle))
    }
  })
  
  //on load, set device type
  if(navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) {
    store.dispatch(setDeviceOrientation(window.orientation))
  } else {
    store.dispatch(setDeviceOrientation(window.screen.orientation.angle))
  }
}


// WEBPACK FOOTER //
// ./src/features/common/PageOrientation.js